import {
  ScrollToTop,
  ThemeProvider,
  CookieProvider,
  CookieConsent,
  ErrorBoundary,
  useCookieConsent,
} from '@xanectech/components/shared';

import { TooltipProvider, Toaster } from '@xanectech/ui/components';

import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AboutLogger } from '@xanectech/data';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

// import { SecureCommAnimation } from './pages/SecureCommAnimation';

import { routes, RouteType } from './AppRoutes';

const ScrollToTopHelper = () => {
  useLocation();
  return <ScrollToTop />;
};

/**
 * Conditionally renders Vercel Analytics and Speed Insights based on analytics
 * consent. Uses the consent context so re-renders automatically when consent changes.
 */
const AnalyticsGuard = () => {
  const { checkCategory } = useCookieConsent();
  if (!checkCategory('analytics')) return null;
  return (
    <>
      <Analytics />
      <SpeedInsights />
    </>
  );
};

const App = () => {
  return (
    <ThemeProvider defaultTheme='light' storageKey='xanectech-home-theme'>
      <CookieProvider appName='home'>
        <ErrorBoundary>
          <TooltipProvider delayDuration={500} skipDelayDuration={200}>
            <Toaster />
            <CookieConsent />
            <AnalyticsGuard />
            <BrowserRouter>
              <ScrollToTopHelper />
              <AboutLogger appName='XanecTech' />
              <Routes>
                {routes().map((route: RouteType) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </ErrorBoundary>
      </CookieProvider>
    </ThemeProvider>
  );
};

export default App;
